module.exports = __webpack_public_path__ + "img/icon_assistant_photo.67d2f4dc.svg";